import NewsAd from "./NewsAd";

export default () => (
  <NewsAd
    unit="/parallax"
    className="parallax"
    sizes={{
      desktop: [300, 250],
      mobile: [300, 250],
    }}
  />
);
